import React from "react";
import { observer } from "mobx-react";
import { Avatar, Card } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { useStores } from "../../../store";
import { Page } from "../../../models/page";
import { Container, CardItemText, Spinner } from "../../../components";
import "./index.scss";
import { useGet } from "../../../hooks/useGet";

var CardItem = function CardItem(_ref) {
  var title = _ref.title,
      done = _ref.done,
      description = _ref.description,
      durationText = _ref.durationText,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: "tatum-card-item",
    onClick: onClick
  }, done ? /*#__PURE__*/React.createElement(CheckCircleFilled, {
    style: {
      color: "#76B947",
      fontSize: "40px",
      marginRight: "10px"
    }
  }) : /*#__PURE__*/React.createElement(Avatar, {
    style: {
      height: "40px",
      width: "40px",
      marginRight: "10px"
    }
  }), /*#__PURE__*/React.createElement(CardItemText, {
    title: title,
    description: description,
    secondDescription: durationText
  }));
};

var SpinnerCard = function SpinnerCard() {
  return /*#__PURE__*/React.createElement(Card, {
    style: {
      display: "flex",
      justifyContent: "center"
    },
    title: /*#__PURE__*/React.createElement(Spinner, null)
  });
};

var CardsContent = function CardsContent(_ref2) {
  var data = _ref2.data;

  var _useStores = useStores(),
      pageStore = _useStores.pageStore;

  var gridStyle = {
    width: "100%",
    align: "center"
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card.Grid, {
    hoverable: false,
    style: gridStyle
  }, /*#__PURE__*/React.createElement(CardItem, {
    title: "Woocommerce plugin installed",
    done: data.isWoocommerceInstalled
  })), /*#__PURE__*/React.createElement(Card.Grid, {
    hoverable: true,
    style: gridStyle
  }, /*#__PURE__*/React.createElement(CardItem, {
    title: "Get your Tatum API key",
    done: false,
    description: "Choose your API plan and start minting NFTs",
    durationText: "3 minutes",
    onClick: function onClick() {
      return pageStore.setPage(Page.GET_API_KEY);
    }
  })));
};

var Guideline = observer(function () {
  var _useGet = useGet("/setup"),
      data = _useGet.data;

  return /*#__PURE__*/React.createElement(Container, {
    isGridCard: true
  }, /*#__PURE__*/React.createElement(Card, {
    title: "Complete these tasks to start selling your products as NFTs"
  }, data ? /*#__PURE__*/React.createElement(CardsContent, {
    data: data
  }) : /*#__PURE__*/React.createElement(SpinnerCard, null)));
});
export { Guideline };